import { createRouter, createWebHistory } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import AppLayout from '@/layouts/AppLayout.vue';
import LandingPage from '@/pages/LandingPage.vue';
import HomePage from '@/pages/HomePage.vue';
import WallPage from '@/pages/WallPage.vue';
import UsersPage from '@/pages/UsersPage.vue';
import UserProfilePage from '@/pages/UserProfilePage.vue';
import GiftsPage from '@/pages/GiftsPage.vue';
import PlaygroundPage from '@/pages/PlaygroundPage.vue';
import TriWishesPage from '@/pages/TriWishesPage.vue';
import ForestQuestPage from '@/pages/ForestQuestPage.vue';
import SettingsPage from '@/pages/SettingsPage.vue';
import AdminPage from '@/pages/AdminPage.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'landing',
      component: LandingPage,
      meta: { guestOnly: true },
    },
    {
      path: '/app',
      component: AppLayout,
      meta: { requiresAuth: true },
      children: [
        { path: '', redirect: '/app/home' },
        { path: 'home', name: 'home', component: HomePage },
        { path: 'wall', name: 'wall', component: WallPage, meta: { fillHeight: true } },
        { path: 'users', name: 'users', component: UsersPage },
        { path: 'users/:id', name: 'user-profile', component: UserProfilePage },
        { path: 'gifts', name: 'gifts', component: GiftsPage },
        { path: 'playground', name: 'playground', component: PlaygroundPage },
        { path: 'playground/tri-wishes', name: 'tri-wishes', component: TriWishesPage },
        {
          path: 'playground/forest-quest',
          name: 'forest-quest',
          component: ForestQuestPage,
          meta: { fillHeight: true },
        },
        { path: 'settings', name: 'settings', component: SettingsPage },
        {
          path: 'admin',
          name: 'admin',
          component: AdminPage,
          meta: { requiresAdmin: true },
        },
      ],
    },
  ],
});

router.beforeEach(async (to) => {
  const { isAuthenticated, isAdmin, restoreSession } = useAuth();

  if (to.meta.requiresAuth) {
    if (!isAuthenticated.value) {
      const restored = await restoreSession();
      if (!restored) {
        return { name: 'landing' };
      }
    }
  }

  if (to.meta.requiresAdmin && !isAdmin.value) {
    return { name: 'home' };
  }

  if (to.meta.guestOnly && isAuthenticated.value) {
    return { name: 'home' };
  }

  return true;
});

export default router;
